var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }